import React, { useEffect, useRef, useState } from 'react';
import { styled } from '@linaria/react';

const DOBDivider = styled.span`
  color: #C9C9C9;
  margin: 0 5px;
  font-size: 16;
  font-weight: 600;
`;


const DOBInputGroup = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 8px;
  border-bottom: 1px solid #c4c4c4;
`;

const DateInput = styled.input<{ name: string, width?: number }>`
  display: block;
  border: none;
  outline: none;
  padding: 0;
  text-align: center;
  width: ${(props) => (props.width ? props.width + 'px' : props.name === 'year' ? '40px' : '28px')};
  color: #883e89;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.4;
  -webkit-appearance: none;
  -moz-appearance: textfield;
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  &::placeholder {
    color: #C9C9C9;
    font-weight: 400;
  }
  &:-webkit-autofill {
    transition: background-color 5000s ease-in-out 0s;
    -webkit-text-fill-color: #883e89 !important;
    font-size: 16px;
    font-weight: 600;
  }
`;

interface IDate {
  day?: string;
  month?: string;
  year?: string;
}

export interface DayOfBirthProps {
  value?: IDate;
  name?: string;
  onChange?: (e: any) => void;
  onFocus?: () => void;
  error?: any;
}



function DayOfBirth({ value, onChange, onFocus, name, error }: DayOfBirthProps) {
  const [date, setDate] = useState<IDate | undefined>(value);
  const refDay = useRef<HTMLInputElement>(null);
  const refMonth = useRef<HTMLInputElement>(null);
  const refYear = useRef<HTMLInputElement>(null);

  const refDayText = useRef<HTMLDivElement>(null);
  const [dayTextLength, setDayTextLength] = useState(0);
  const refMonthText = useRef<HTMLDivElement>(null);
  const [monthTextLength, setMonthTextLength] = useState(0);
  const refYearText = useRef<HTMLDivElement>(null);
  const [yearTextLength, setYearTextLength] = useState(0);

  const dayDividerRef = useRef<HTMLSpanElement>(null);
  const monthDividerRef = useRef<HTMLSpanElement>(null);

  // const clearField=(name:string)=>{
  //   let target = { name:name, value:"" };
  //   handleChange({target});
  //   if (onFocus) {
  //     onFocus();
  //   }
  // }

  useEffect(() => {
    setDate(value);
  }, [value?.day, value?.month, value?.year]);

  const handleChange = (event: any) => {
    const { value, name: nameTarget, maxLength } = event.target;
    switch (nameTarget) {
      case 'day':
        if (value.length === maxLength || value.length > maxLength) {
          if (refMonth.current?.value.length.toString() === refMonth.current?.maxLength.toString()) {
            refDay.current?.blur();
          }
          else {
            refMonth.current?.focus();
            dayDividerRef.current!.style.color = '#883E89';
          }
        }
        break;
      case 'month':
        if (value.length === maxLength) {
          if (refYear.current?.value.length.toString() === refYear.current?.maxLength.toString()) {
            refMonth.current?.blur();
          }
          else {
            refYear.current?.focus();
            monthDividerRef.current!.style.color = '#883E89';
          }
        }
        break;
      case 'year':
        if (value.length === maxLength) {
          refYear.current?.blur();
        }
        break;
      default:
        break;
    }
    const nextDate = { ...date, [nameTarget]: value };
    setDate(nextDate);
    if (onChange) {
      onChange({
        ...event,
        target: { ...event.target, name, value: nextDate },
      });
    }
  };

  useEffect(() => {
    setTimeout(() => {
      if (refDayText.current) {
        setDayTextLength(date?.day ? refDayText.current.offsetWidth : 0);
      }
    }, 100);
  }, [date?.day])

  useEffect(() => {
    if (date?.month)
      dayDividerRef.current!.style.color = "#883E89";
    setTimeout(() => {
      if (refMonthText.current) {
        setMonthTextLength(date?.month ? refMonthText.current!.offsetWidth : 0);
      }
    }, 100);
  }, [date?.month])

  useEffect(() => {
    if (date?.year) {
      monthDividerRef.current!.style.color = "#883E89";
    }
    setTimeout(() => {
      if (refYearText.current) {
        setYearTextLength(date?.year ? refYearText.current!.offsetWidth : 0);
      }
    }, 100);
  }, [date?.year])


  return (
    <>
      <DOBInputGroup>
        <DateInput
          width={dayTextLength}
          value={date?.day ?? ""}
          type="text"
          name="day"
          ref={refDay}
          pattern="\d*"
          min={0}
          maxLength={2}
          onChange={(e: any) => {
            let formatted_input = e.target.value.replace(/[^0-9]+/, '');
            console.log("formatet", formatted_input, e.target.maxLength);
            handleChange({ ...e, target: { ...e.target, 'value': formatted_input, 'name': e.target.name, 'maxLength': e.target.maxLength } });
          }}
          placeholder="DD"
        />
        <DOBDivider ref={dayDividerRef}>-</DOBDivider>
        <DateInput
          width={monthTextLength}
          value={date?.month ?? ""}
          type="text"
          pattern="\d*"
          name="month"
          ref={refMonth}
          min={0}
          maxLength={2}
          onChange={(e: any) => {
            let formatted_input = e.target.value.replace(/[^0-9]+/, '');
            handleChange({ ...e, target: { ...e.target, 'value': formatted_input, 'name': e.target.name, 'maxLength': e.target.maxLength } });
          }}
          placeholder="MM"
        />
        <DOBDivider ref={monthDividerRef}>-</DOBDivider>
        <DateInput
          width={yearTextLength}
          value={date?.year ?? ""}
          type="text"
          pattern="\d*"
          name="year"
          ref={refYear}
          min={0}
          maxLength={4}
          onChange={(e: any) => {
            let formatted_input = e.target.value.replace(/[^0-9]+/, '');
            handleChange({ ...e, target: { ...e.target, 'value': formatted_input, 'name': e.target.name, 'maxLength': e.target.maxLength } });
          }}
          placeholder="YYYY"
        />
      </DOBInputGroup>
      <div style={{ height: 0, opacity: 0 }}>
        <div style={{ display: 'inline-block', fontSize: 16, fontWeight: 600 }} ref={refDayText}>{date?.day}</div>
        <div style={{ display: 'inline-block', fontSize: 16, fontWeight: 600 }} ref={refMonthText}>{date?.month}</div>
        <div style={{ display: 'inline-block', fontSize: 16, fontWeight: 600 }} ref={refYearText}>{date?.year}</div>
      </div>
    </>
  );
}

export default DayOfBirth;
